import { render, staticRenderFns } from "./Sketchpad.vue?vue&type=template&id=e7a8563c&scoped=true"
import script from "./Sketchpad.vue?vue&type=script&lang=js"
export * from "./Sketchpad.vue?vue&type=script&lang=js"
import style0 from "./Sketchpad.vue?vue&type=style&index=0&id=e7a8563c&prod&lang=scss&scoped=true"
import style1 from "./Sketchpad.vue?vue&type=style&index=1&id=e7a8563c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a8563c",
  null
  
)

export default component.exports